

export interface Paginate {
  pageNumber: number;
  pageSize: number;
}
export const initPaginate = (pageNumber = 1, pageSize = 10): Paginate => {
  return {
    pageNumber,
    pageSize,
  };
};